/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Thankyou_VerifiedInputs */

const en_thankyou_verified = /** @type {(inputs: Thankyou_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verified`)
};

const es_thankyou_verified = /** @type {(inputs: Thankyou_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verificado`)
};

const fr_thankyou_verified = /** @type {(inputs: Thankyou_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vérifié`)
};

const de_thankyou_verified = /** @type {(inputs: Thankyou_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifiziert`)
};

const id_thankyou_verified = /** @type {(inputs: Thankyou_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terverifikasi`)
};

/** @type {(inputs: Thankyou_VerifiedInputs) => LocalizedString} */
const ja_thankyou_verified = en_thankyou_verified;

/** @type {(inputs: Thankyou_VerifiedInputs) => LocalizedString} */
const zh_thankyou_verified = en_thankyou_verified;

/** @type {(inputs: Thankyou_VerifiedInputs) => LocalizedString} */
const ar_thankyou_verified = en_thankyou_verified;

/** @type {(inputs: Thankyou_VerifiedInputs) => LocalizedString} */
const it_thankyou_verified = en_thankyou_verified;

/** @type {(inputs: Thankyou_VerifiedInputs) => LocalizedString} */
const ru_thankyou_verified = en_thankyou_verified;

/** @type {(inputs: Thankyou_VerifiedInputs) => LocalizedString} */
const pt_thankyou_verified = en_thankyou_verified;

/** @type {(inputs: Thankyou_VerifiedInputs) => LocalizedString} */
const ko_thankyou_verified = en_thankyou_verified;

/**
* | output |
* | --- |
* | "Verified" |
*
* @param {Thankyou_VerifiedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const thankyou_verified = /** @type {((inputs?: Thankyou_VerifiedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Thankyou_VerifiedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_thankyou_verified(inputs)
	if (locale === "es") return es_thankyou_verified(inputs)
	if (locale === "fr") return fr_thankyou_verified(inputs)
	if (locale === "de") return de_thankyou_verified(inputs)
	if (locale === "ja") return ja_thankyou_verified(inputs)
	if (locale === "zh") return zh_thankyou_verified(inputs)
	if (locale === "ar") return ar_thankyou_verified(inputs)
	if (locale === "id") return id_thankyou_verified(inputs)
	if (locale === "it") return it_thankyou_verified(inputs)
	if (locale === "ru") return ru_thankyou_verified(inputs)
	if (locale === "pt") return pt_thankyou_verified(inputs)
	return ko_thankyou_verified(inputs)
});